<template>
  <div class="swiper-container">
    <div class="swiper-wrapper">
      <div
        v-for="i in Math.ceil(
          urgentJobList.length / (row || 3)
        )"
        :key="i"
        class="swiper-slide"
        :class="
          urgentJobList.length > 0 &&
          i == Math.ceil(urgentJobList.length / (row || 3)) &&
          platform != 'PC'
            ? 'card-width'
            : ''
        "
      >
        <div class="swiper-slide-card">
          <div
            class="card job_con sensors_exposure"
            v-for="(item, index) in urgentJobList.slice(row * i - row, row * i)"
            :key="index"
            @click="clickJobCard(item, index)"
            sensorsname="JobShortExposure"
            :sensorsdata="buildJobShortExposureParams(item, index)"
          >
            <div class="job-body">
              <div class="c-top">
                <!-- 岗位名称 -->
                <div class="name van-ellipsis">
                {{ item.jobName }}
                </div>
                <!-- 薪资 -->
                <div class="salary">
                  {{ item.provideSalaryString }}
                </div>
              </div>
              <div class="c-tags">
                <div class="c-tags-left">
                  <!-- 公司名称 -->
                  <div class="tag c-comname">
                    {{ item.companyName }}
                  </div>
                  <!-- 公司类型、公司规模 -->
                  <div class="tag type-string">
                    {{ item.companyTypeString }}
                  </div>
                </div>
                <div class="tag c-tags-right">
                  {{ item.companySizeString }}
                </div>
              </div>
              <div class="c-ope">
                <div class="c-bottom">
                  <div class="city-name van-ellipsis" v-if="item.jobAreaString">
                    {{ item.jobAreaString }}
                  </div>
                  <!--网申标识-->  
                  <!-- 引导按钮：buttonType    1-去聊聊   2-投递    3-不显示 -->
                  <div v-if="item.isFromXyx" class="xy">网申</div>
                </div>
                <div v-if="item.isApply" class="applyed">已投递</div>
                <div v-else-if="item.isExpire" class="applyed">已过期</div>
                <div
                v-else
                  class="apply"
                  @click.stop="gotoDeliver(item, index)"
                >
                  <img src="@/assets/img/activity/send-white@2x.png" alt="" />
                  投递
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import SelectedSvg from './SelectedSvg.vue'
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  name: "SwiperContainerH5",
  components: { SelectedSvg },
  props: {
    componentConfig: {
      type: Object,
      default: () => {},
    },
    urgentJobList: {
      type: Array,
      default: () => [],
    },
    selectedJobIds: {
      type: Array,
      default: () => [],
    },
    buttonColor:{
        type: String,
        default:''
      },
    row: {
      type: Number,
        default: () => {
          return 2;
        },
    },
  },
  data() {
    return {
      mySwiper: null,
      keyRandom: Math.floor(100 + Math.random() * 900),
    };
  },
  computed: {
    ...mapState(["commonStore", "resumeStore"]),
    platform() {
      return this.commonStore.platform;
    },
  },
  mounted() {
    // this.initSwiper();
  },
  methods: {
    initSwiper() {
      let self = this;
      this.mySwiper = new Swiper(`.swiper-container-${this.keyRandom}`, {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        slidesPerGroup:1,//明确分组为1
        spaceBetween: 0,
        loop: false, // 禁用循环模式
        resistanceRatio:0.8,//默认开启惯性弹性效果
        on: {
        touchStart: function(event) {
          if (event.changedTouches && event.changedTouches.length > 0) {
          // 记录触点开始位置
            self.touchStartX = event.changedTouches[0].pageX;
          }

        },
        touchEnd: function(event) {
          if (event.changedTouches && event.changedTouches.length > 0) {
            // 记录触点结束位置
            self.touchEndX = event.changedTouches[0].pageX;
          }

        }
      }
      });
    },
    ...mapActions("applyJobStore", ["applyJob", "batchApplyJob"]),
    clickJobCard(item, index) {
      this.$emit("clickJobCard", item, index);
    },
    buildJobShortExposureParams(item, index) {
      if (this.goodRank !== "") {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length,
          {
            subContentRank: this.goodRank,
          }
        );
      } else {
        return this.$base.getJobShortExposureParams(
          item,
          index,
          this.urgentJobList.length
        );
      }
    },
    clickCompany(item, index) {
      this.$emit("clickCompany", item, index);
    },
    gotoDeliver(item, index) {
      this.$emit("gotoDeliver", item, index);
    },
    welfare(jobTags) {
      return jobTags.join(",");
    },
    buttonTypeChat(item) {
        let platform = this.platform;
        let isApp = this.$store.getters.isApp;
        // TODO 测试删除
        // platform = "yjsApp"
        // isApp = true
        //
        if (isApp) {
          if (platform == "51jobApp") {
            // 51
            return item.buttonType == 1;
          } else if (platform == "yjsApp") {
            // yjs
            return item.isApply || item.buttonType == 1;
          }
        }
        return false;
      },
  },
};
</script>
<style scoped lang="less">
  @import "./SwiperContainer.less";
</style>